export function parseMoney(field) {
  if (field) return Number(field.amount)
  else return null
}
